import React from 'react';

const RequestHeader = () => {
    return (
        <div className="row">
            <div className="col-md-2"><b>Разпределено на</b></div>
            <div className="col-md-1"><b>Дата</b></div>
            <div className="col-md-1"><b>Номер</b></div>
            <div className="col-md-2"><b>Обект</b></div>
            <div className="col-md-2"><b>Статус</b></div>
            <div className="col-md-2"><b>Тип</b></div>
            <div className="col-md-2"><b>Адрес</b></div>
        </div>

    )
}

export default RequestHeader;